import { api } from 'app/core/services/base/api.service'
import { CommonResponse } from 'app/core/services/base/response.service'

import { Ath0101CtlrIn, Ath0101CtlrOut } from 'app/core/models/api/ath/ath0101'
import { Ath0102CtlrIn, Ath0102CtlrOut } from 'app/core/models/api/ath/ath0102'
import { Ath0104CtlrIn, Ath0104CtlrOut } from 'app/core/models/api/ath/ath0104'
import { Ath0301CtlrIn, Ath0301CtlrOut } from 'app/core/models/api/ath/ath0301'
import { Ath0302CtlrIn, Ath0302CtlrOut } from 'app/core/models/api/ath/ath0302'
import { Ath0303CtlrIn, Ath0303CtlrOut } from 'app/core/models/api/ath/ath0303'
import { Com0305CtlrIn, Com0305CtlrOut } from 'app/core/models/api/com/com0305'
import { Ath0103CtlrOut, Ath0103CtlrIn } from 'app/core/models/api/ath/ath0103'
import { Ath0205CtlrOut, Ath0205CtlrIn } from 'app/core/models/api/ath/ath0205'
import { Com0302CtlrOut } from 'app/core/models/api/com/com0302'
import { Ath0401CtlrIn, Ath0401CtlrOut } from 'app/core/models/api/ath/ath0401'
import { Ath0402CtlrIn, Ath0402CtlrOut } from 'app/core/models/api/ath/ath0402'
import { Ath0403CtlrIn, Ath0403CtlrOut } from 'app/core/models/api/ath/ath0403'
import { Ath0404CtlrIn, Ath0404CtlrOut } from 'app/core/models/api/ath/ath0404'
import { Ath0405CtlrIn, Ath0405CtlrOut } from 'app/core/models/api/ath/ath0405'
import { Ath0406CtlrIn, Ath0406CtlrOut } from 'app/core/models/api/ath/ath0406'

const suffixPath = 'com/ath'

const postApi = api.injectEndpoints({
    endpoints: (build) => ({
        // 역계좌인증 요청
        selectAth0101: build.query<Ath0101CtlrOut, Ath0101CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath01/ath0101`,
                method: 'POST',
                body,
            }),
            extraOptions: { handleLocally: true },
            transformResponse: CommonResponse<Ath0301CtlrOut>,
        }),
        // 당행계좌인증 검증
        selectAth0102: build.query<Ath0102CtlrOut, Ath0102CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath01/ath0102`,
                method: 'POST',
                body,
            }),
            extraOptions: { handleLocally: true },
            transformResponse: CommonResponse<Ath0102CtlrOut>,
        }),
        // 적립식 당타계좌확인
        selectAth0103: build.query<Ath0103CtlrOut, Ath0103CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath01/ath0103`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0103CtlrOut>,
        }),
        // 역계좌인증 검증
        selectAth0104: build.query<Ath0104CtlrOut, Ath0104CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath01/ath0104`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0104CtlrOut>,
        }),
        // 휴대폰 본인 인증 문자 요청
        selectAth0301: build.query<Ath0301CtlrOut, Ath0301CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath03/ath0301`,
                method: 'POST',
                body,
            }),
            // onCacheEntryAdded(arg, api) {},
            transformResponse: CommonResponse<Ath0301CtlrOut>,
        }),

        /**
         * 휴대폰 본인 인증 문자 검증
         */
        selectAth0302: build.query<Ath0302CtlrOut, Ath0302CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath03/ath0302`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0302CtlrOut>,
            extraOptions: { handleLocally: true },
        }),

        /**
         * 휴대폰 본인 인증 13자리 세션넣기
         */
        selectAth0303: build.query<Ath0303CtlrOut, Ath0303CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath03/ath0303`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0303CtlrOut>,
            extraOptions: { handleLocally: true },
        }),

        /**
         * 우편번호 조회
         */
        selectAth0305: build.query<Com0305CtlrOut, Com0305CtlrIn>({
            query: (body) => ({
                url: `prd/com/com03/com0305`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Com0305CtlrOut>,
        }),
        // 고객 (주소) 정보 조회
        selectCom0302: build.query<Com0302CtlrOut, void>({
            query: (body) => ({
                url: `/prd/com/com03/com0302`,
                method: 'POST',
                body: {},
            }),
            transformResponse: CommonResponse<Com0302CtlrOut>,
            extraOptions: { handleLocally: true },
        }),
        // 안면인식
        selectAth0205: build.query<Ath0205CtlrOut, Ath0205CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath02/ath0205`,
                method: 'POST',
                body: {},
            }),
            transformResponse: CommonResponse<Ath0205CtlrOut>,
            extraOptions: { handleLocally: true },
        }),

        /**
         * 인증기관 목록 조회
         */
        selectAth0401: build.query<Ath0401CtlrOut, Ath0401CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath04/ath0401`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0401CtlrOut>,
        }),

        /**
         * 인증기관 상태 조회
         */
        selectAth0402: build.query<Ath0402CtlrOut, Ath0402CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath04/ath0402`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0402CtlrOut>,
        }),

        /**
         * 본인확인 검증
         */
        selectAth0403: build.query<Ath0403CtlrOut, Ath0403CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath04/ath0403`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0403CtlrOut>,
        }),

        /**
         * 공공마이데이터 전자서명 원문조회
         */
        selectAth0404: build.query<Ath0404CtlrOut, Ath0404CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath04/ath0404`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0404CtlrOut>,
        }),

        /**
         * 전자서명 검증
         */
        selectAth0405: build.query<Ath0405CtlrOut, Ath0405CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath04/ath0405`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0405CtlrOut>,
        }),

        /**
         * 본인인증 입력정보 조회
         */
        selectAth0406: build.query<Ath0406CtlrOut, Ath0406CtlrIn>({
            query: (body) => ({
                url: `${suffixPath}/ath04/ath0406`,
                method: 'POST',
                body,
            }),
            transformResponse: CommonResponse<Ath0406CtlrOut>,
        }),
    }),
})

export const {
    useLazySelectAth0101Query,
    useLazySelectAth0102Query,
    useLazySelectAth0103Query,
    useLazySelectAth0104Query,
    useLazySelectAth0301Query,
    useLazySelectAth0302Query,
    useLazySelectAth0303Query,
    useLazySelectAth0305Query,
    useLazySelectCom0302Query,
    useLazySelectAth0205Query,
    useLazySelectAth0401Query,
    useLazySelectAth0402Query,
    useLazySelectAth0403Query,
    useLazySelectAth0404Query,
    useLazySelectAth0405Query,
    useLazySelectAth0406Query,
} = postApi

export const {
    endpoints: { selectAth0302, selectCom0302, selectAth0205 },
} = postApi
